<template>
  <modal :name="name" :width="800" :height="600">
    <div class="modal-create-population-container">
      <iframe :src="apolloDomain + '/apollo/vheart/create_population'" width="100%" height="100%"></iframe>
    </div>
  </modal>
</template>


<script>
import { getEnvVar } from '@/utils/envUtils'

export default {
  name: 'ModalCreatePopulation',
  components: {},
  props: ["name"],
  data() {
    return {
      apolloDomain: null
    }
  },
  methods: {
    emitPopulationCreatedEvent(event) {
      // Only capture events from Apollo iframe
      if (event.origin == this.apolloDomain) {
        const messageType = event.data.message_type;
        const populationName = event.data.population_name;
        if (messageType == "population-created") {
          this.$emit('populationCreated', populationName);
        }
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.emitPopulationCreatedEvent);
    this.apolloDomain = getEnvVar("VUE_APP_APOLLO_URL");
  }
}
</script>


<style lang="stylus" scoped>
.modal-create-population-container
  display: flex
  height: 100%
  width: 100%
  padding: 20px

  iframe
    border: none


</style>